import api from '../../api/http-common'

const getActivityLogList = (data?) =>
  api.post('/activity-logs/index', data)

const getActivityLogOptions = (data?) =>
  api.post('/activity-logs/get-index-data', data)

const getActivityLogsHistory = () =>
  api.post('/activity-log-histories/index')

const ActivityLogService = {
  getActivityLogList,
  getActivityLogOptions,
  getActivityLogsHistory
}

export default ActivityLogService
